// Configuración centralizada para el sistema de novedades

export const WHATS_NEW_CONFIG = {
  // Versión actual del sistema - ACTUALIZA ESTO para nuevas versiones
  CURRENT_VERSION: '1.29.0',

  // Configuración del comportamiento
  SETTINGS: {
    // Delay antes de mostrar el modal (en ms)
    SHOW_DELAY: 2000,

    // Si se debe mostrar automáticamente
    AUTO_SHOW: true,

    // Clave para localStorage
    STORAGE_KEY: 'whats-new-seen-version',

    // Solo mostrar a usuarios autenticados
    REQUIRE_AUTH: true
  },

  // Configuración de desarrollo
  DEV: {
    // Mostrar logs en consola
    ENABLE_LOGS: process.env.NODE_ENV === 'development',

    // Habilitar herramientas de desarrollo
    ENABLE_DEV_TOOLS: process.env.NODE_ENV === 'development'
  }
} as const

// Función helper para logging en desarrollo
export const devLog = (message: string, data?: unknown) => {
  if (WHATS_NEW_CONFIG.DEV.ENABLE_LOGS) {
    console.log(`[WhatsNew] ${message}`, data || '')
  }
}

// Tipos para TypeScript
export type WhatsNewVersion = string
export type WhatsNewStorageKey = typeof WHATS_NEW_CONFIG.SETTINGS.STORAGE_KEY
